import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Lock } from '@mui/icons-material';

export function Unauthorized() {
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '60vh',
				padding: 4,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					maxWidth: 600,
					textAlign: 'center',
					gap: 3,
				}}
			>
				<Box
					sx={{
						width: 80,
						height: 80,
						borderRadius: '50%',
						backgroundColor: 'error.light',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Lock sx={{ fontSize: 40, color: 'error.main' }} />
				</Box>

				<Typography variant="h4" component="h1" fontWeight={600}>
					Access Denied
				</Typography>

				<Typography variant="body1" color="text.secondary">
					You don't have permission to access this resource. If you believe this
					is an error, please contact your system administrator.
				</Typography>

				<Button
					variant="contained"
					onClick={() => navigate('/')}
					sx={{ mt: 2 }}
				>
					Return to Dashboard
				</Button>
			</Box>
		</Box>
	);
}
